<div class="row">
  <div class="col-sm-12">
    <div class="form-group">
      <label class="checkbox-inline">
        <input type="checkbox" [(ngModel)]="targetAllUsers"> Apply to all users
      </label>
    </div>

    <div *ngIf="!targetAllUsers" class="row">
      <div class="col-sm-6">
        <label>Target specific roles</label>
        <div class="password-policy-select-list">
          <div *ngFor="let role of allRoles" class="checkbox">
            <label>
              <input type="checkbox" [(ngModel)]="selectedRoleIds[role.id]"> {{role.name}}
            </label>
          </div>
        </div>
      </div>

      <div class="col-sm-6">
        <label>Target specific users</label>
        <div class="password-policy-select-list">
          <div *ngFor="let user of allUsers" class="checkbox">
            <label>
              <input type="checkbox" [(ngModel)]="selectedUserIds[user.id]"> {{user.friendlyName || user.userName}}
            </label>
          </div>
        </div>
      </div>
    </div>

    <div class="row padding-sm-vr">
      <div class="col-sm-3">
        <label>Warning window before each deadline (days)</label>
        <input type="number" min="1" class="form-control" [(ngModel)]="requiredInDays">
      </div>
      <div class="col-sm-3">
        <label>Repeats every (days)</label>
        <input type="number" min="1" class="form-control" [(ngModel)]="repeatIntervalDays">
      </div>
    </div>

    <div class="row padding-sm-vr">
      <div class="col-sm-12">
        <button type="button" class="btn btn-primary" [disabled]="isSaving" (click)="activate()">Activate policy</button>
      </div>
    </div>

    <hr class="separator-hr" />

    <h5>Currently enforced</h5>
    <table class="table table-striped" *ngIf="assignments.length">
      <thead>
        <tr>
          <th>User</th>
          <th>Required by</th>
          <th>Warning window</th>
          <th>Repeats every</th>
          <th>Status</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let a of assignments">
          <td>{{a.fullName || a.userName}}</td>
          <td>{{a.requiredByDate | date:'medium'}}</td>
          <td>{{a.requiredInDays}} day(s) before deadline</td>
          <td>{{a.repeatIntervalDays}} day(s)</td>
          <td>
            <span *ngIf="a.isOverdue" class="label label-danger">Overdue</span>
            <span *ngIf="!a.isOverdue" class="label label-info">Pending</span>
          </td>
          <td>
            <button type="button" class="btn btn-link" (click)="deactivate(a)">Remove</button>
          </td>
        </tr>
      </tbody>
    </table>
    <p *ngIf="!assignments.length && !isLoading">No users currently have an active password-change policy.</p>
  </div>
</div>
